/**
 * Shared "More Games" page component used across all games.
 * Displays list of available games and email signup form.
 */

import React from 'react';
import MoreGames from '../../MoreGames/MoreGames';
import EmailSignupBox from '../../EmailSignupBox/EmailSignupBox';
import TermsFooter from '../../TermsFooter/TermsFooter';
import { CommonPageId } from '../../Page/PageTypes';

/**
 * Props for the PageMore component.
 */
interface PageMoreProps {
  onRequestClose?: () => void;
  navigateToPage?: (pageId: string, navigationProps?: any) => void;
}

/**
 * More Games page component.
 * 
 * This page is shared across all games and shows:
 * - List of available games for cross-promotion
 * - Link to Mental Mint home page
 * - Email signup form for user engagement
 * - Terms and copyright footer
 * 
 * The same component is used but displayed differently per game:
 * - TileClicker: Modal overlay
 * - Witocracy: Full screen page
 * - Future games: Configurable via PageConfig
 */
export const PageMore: React.FC<PageMoreProps> = ({
  onRequestClose,
  navigateToPage
}) => {  
  const handleTermsClick = () => {
    if (navigateToPage) {
      navigateToPage(CommonPageId.Terms);
    }
  };

  return (
    <div className="page-more">
      <MoreGames includeLandingPageLink={true} />

      {/* Horizontal divider */}
      <div style={{
          width: '100%',
          height: '1px',
          backgroundColor: 'rgba(130, 130, 130, 0.5)',
          margin: '1.5rem 0',
          opacity: '0.8'
      }} />
      
      <EmailSignupBox />
      <TermsFooter onTermsClick={handleTermsClick} />
    </div>
  );
};
